import { Box } from '@mui/material'
import ImageCompanyLogo from '../../image-company-logo'
import './styles.scss'

export const BootStrapSpinner = ({ size }: ICattleLogoSpinner) => {
   return <CattleLogoSpinner size={ size } />
}

interface ICattleLogoSpinner
{
    size?: string
}

export const CattleLogoSpinner = ({ size }: ICattleLogoSpinner) => {
    return (
        <div className="align-middle">
            <div className={`spin cpv-spin ${ size || 'sm' }`}>
                <ImageCompanyLogo />
            </div>
        </div>
    )
}

export const CircularProgress = ({ size }: ICattleLogoSpinner) => {
    return <CattleLogoSpinner size={size} />
}

export const OverlaySpinner = ({ size = 'sm' }: ICattleLogoSpinner) => {
    return (
        <Box sx={{
            zIndex: 1501,
            backgroundColor: 'rgba(88, 123, 148, 0.8)',
            backdropFilter: 'blur(8px)',
            filter: 'saturate(0.4)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }}>
            <CattleLogoSpinner size={size} />
        </Box>
    )
}